/// <reference path="../../types.d.ts" />
import { connect } from 'react-redux';
import { buildDispatchable } from '../../actions/_action-utilities';
import history from '../../history';
import { AddGroup } from './groups-add-form';
import { groupActions } from '../../actions/groups';
const mapStateToProps = function(state) {
    const { group, organization } = state;
    return {
        ...group,
        errors: group.groupsFormErrors,
        tenantId: organization.activeOrganization.tenantId
    };
};
const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        handleSave: (group)=>{
            runDispatchable(()=>{
                return dispatch(groupActions.saveGroup(group));
            });
        },
        handleCancel: ()=>{
            runDispatchable(()=>{
                history.goBack();
            });
        }
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddGroup);
